import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0abb3d58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-12 d-flex" }
const _hoisted_5 = { class: "card mb-25 border-0 rounded-0 bg-white flex-grow-1" }
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_7 = {
  key: 1,
  class: "alert alert-warning mb-0",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadCrumb = _resolveComponent("BreadCrumb")!
  const _component_AutoSystemClassificationResultsTable = _resolveComponent("AutoSystemClassificationResultsTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BreadCrumb, { PageTitle: "Auto System Classification Results" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_ctx.tableName)
                  ? (_openBlock(), _createBlock(_component_AutoSystemClassificationResultsTable, {
                      key: 0,
                      tableName: _ctx.tableName
                    }, null, 8, ["tableName"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, " A results table name was not provided in the route. "))
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}